import { GenIcon } from '../helpers/IconBase.es.js';

const CircleMobileBankingColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "12", fill: "#F0FAFF" }
      },
      {
        tag: "path",
        attr: {
          d: "M6.783 6.52197C6.351 6.52197 6 6.87237 6 7.30497V17.2176C6 17.6496 6.351 18 6.783 18H13.0434C13.4754 18 13.8258 17.6496 13.8258 17.2176V7.30497C13.8258 6.87237 13.4754 6.52197 13.0434 6.52197H6.783Z",
          fill: "#747474"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.39111 16.6962C9.39111 16.9842 9.62451 17.2176 9.91371 17.2176C10.2011 17.2176 10.4345 16.9842 10.4345 16.6962C10.4345 16.4082 10.2011 16.1736 9.91371 16.1736C9.62451 16.1736 9.39111 16.4082 9.39111 16.6962Z",
          fill: "#A0A0A0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.0436 7.82642C6.9002 7.82642 6.7832 7.94282 6.7832 8.08682V15.1308C6.7832 15.2742 6.9002 15.3924 7.0436 15.3924H12.7826C12.9278 15.3924 13.0436 15.2742 13.0436 15.1308V8.08682C13.0436 7.94282 12.9278 7.82642 12.7826 7.82642H7.0436Z",
          fill: "#A0A0A0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.2178 6C10.9304 6 10.6958 6.2334 10.6958 6.522V10.6962C10.6958 10.9842 10.9304 11.2182 11.2178 11.2182H17.4794C17.7668 11.2182 18.0002 10.9842 18.0002 10.6962V6.522C18.0002 6.2334 17.7668 6 17.4794 6H11.2178Z",
          fill: "#42A5DC"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6958 8.34786H18.0002V7.04346H10.6958V8.34786Z",
          fill: "#213E49"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.478 9.52225C11.478 9.73814 11.653 9.91315 11.8689 9.91315H13.9575C14.1734 9.91315 14.3484 9.73814 14.3484 9.52225C14.3484 9.30636 14.1734 9.13135 13.9575 9.13135H11.8689C11.653 9.13135 11.478 9.30636 11.478 9.52225Z",
          fill: "#FEFEFE"
        }
      }
    ]
  })(props);
};

export { CircleMobileBankingColored };
